import { get } from './request'

export async function fetchIntegration() {
  const response = await get<any>('/integration')
  return response
}
